var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (stitch) {
jade_mixins["settings-section"] = jade_interp = function(id, name, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div" + (jade.attr("id", id, true, true)) + (jade.attr("data-id", id, true, true)) + (jade.attr("data-name", label || name, true, true)) + " class=\"settings-section js-settings-section\"><h2 class=\"settings-section__name\">" + (jade.escape(null == (jade_interp = name) ? "" : jade_interp)) + "</h2><div" + (jade.cls(['settings-section__main','js-settings-section__main--' + (id) + ''], [null,true])) + "><div" + (jade.cls(['settings-' + (id) + ''], [true])) + ">");
block && block();
buf.push("</div></div></div>");
};
jade_mixins["settings-section"].call({
block: function(){
buf.push("<div id=\"stitch-credit-cards\">" + (null == (jade_interp = stitch.components.UserSettingsPayments({ mountId: 'stitch-credit-cards' })) ? "" : jade_interp) + "</div>");
}
}, 'payment-methods', '');}.call(this,"stitch" in locals_for_with?locals_for_with.stitch:typeof stitch!=="undefined"?stitch:undefined));;return buf.join("");
};
module.exports = template;